import React from 'react';
import PropTypes from 'prop-types';

import { VpIcon } from '../VpIcon';

import { StyledSocialButton } from './styles';

const twitterLink = 'https://twitter.com/intent/tweet?url=';
export const VpShareToTwitter = ({ link = '' }) => {
  const twitterShareUrl = `${twitterLink}${encodeURIComponent(link)}`;

  return (
    <a href={twitterShareUrl} target="_blank" rel="noopener noreferrer">
      <StyledSocialButton variant="contained">
        <VpIcon icon="Twitter" />
      </StyledSocialButton>
    </a>
  );
};

VpShareToTwitter.propTypes = {
  link: PropTypes.string
};

export default VpShareToTwitter;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpSocialMediaShareButtons/VpShareToTwitter.jsx